import dynamic from "next/dynamic";

export const ConnectedList = dynamic(() => import("./component"));
